function getFocusableElements(container) {
	return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}

class SectionId {
	static #separator = '__';

	static parseId(qualifiedSectionId) {
		return qualifiedSectionId.split(SectionId.#separator)[0]
	}

	static parseSectionName(qualifiedSectionId) {
		return qualifiedSectionId.split(SectionId.#separator)[1]
	}

	static getIdForSection(sectionId, sectionName) {
		return `${sectionId}${SectionId.#separator}${sectionName}`
	}
}

class HTMLUpdateUtility {
	static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
		preProcessCallbacks?.forEach((callback) => callback(newContent));
		const newNodeWrapper = document.createElement('div');
		HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
		const newNode = newNodeWrapper.firstChild;
		const uniqueKey = Date.now();

		oldNode.querySelectorAll('[id], [form]').forEach((element) => {
			element.id && (element.id = `${element.id}-${uniqueKey}`); element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`)
		});
		oldNode.isRemoved = true;
		oldNode.parentNode.insertBefore(newNode, oldNode);
		oldNode.remove();
		postProcessCallbacks?.forEach((callback) => callback(newNode));
	}

	static setInnerHTML(element, html) {
		element.innerHTML = html;

		element.querySelectorAll('script').forEach((oldScriptTag) => {
			const newScriptTag = document.createElement('script'); Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value)
			}); newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML)); oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
		})
	}
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button'); summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open')); if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
	}); if (summary.closest('header-drawer, menu-drawer')) return; summary.parentElement.addEventListener('keyup', onKeyUpEscape)
});

const trapFocusHandlers = {}

	;

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];
	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;
		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

		;

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

		;

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return;

		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus()
		}

		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus()
		}
	}

		;
	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);
	elementToFocus.focus();

	if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
		elementToFocus.setSelectionRange(0, elementToFocus.value.length)
	}
}

try {
	document.querySelector(':focus-visible')
}

catch (e) {
	focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
	const navKeys = ['ARROWUP',
		'ARROWDOWN',
		'ARROWLEFT',
		'ARROWRIGHT',
		'TAB',
		'ENTER',
		'SPACE',
		'ESCAPE',
		'HOME',
		'END',
		'PAGEUP',
		'PAGEDOWN',
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = !1
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = !0
	});

	window.addEventListener('focus', () => {
		if (currentFocusedElement) currentFocusedElement.classList.remove('focused'); if (mouseClick) return; currentFocusedElement = document.activeElement; currentFocusedElement.classList.add('focused')
	}

		, !0)
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
	});

	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	});
	document.querySelectorAll('video').forEach((video) => video.pause());

	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);
	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;
	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;
	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', !1);
	summaryElement.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');

		this.changeEvent = new Event('change', {
			bubbles: !0
		});
		this.addEventListener('change', this.onInputChange.bind(this));
		this.addEventListener('click', this.onButtonClick.bind(this));
	}

	quantityUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
	}

	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}

	onInputChange(event) {
		if (event.target !== this.input) {
			this.input = this.querySelector('input');
		}
		this.validateQtyRules();
	}

	onButtonClick(event) {
		const button = event.target.closest('button');
		if (!button || !this.contains(button)) return;
		event.preventDefault();

		this.input = this.querySelector('input');
		const previousValue = this.input.value;

		if (button.name === 'plus') {
			if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
				this.input.value = this.input.dataset.min;
			} else {
				this.input.stepUp();
			}
		} else {
			this.input.stepDown();
		}

		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

		if (this.input.dataset.min === previousValue && button.name === 'minus') {
			this.input.value = parseInt(this.input.min);
		}
	}

	validateQtyRules() {
		if (!this.input) return;
		const value = parseInt(this.input.value);

		if (this.input.min) {
			const buttonMinus = this.querySelector(".quantity__button[name='minus']");
			if (buttonMinus) buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
		}

		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
			if (buttonPlus) buttonPlus.classList.toggle('disabled', value >= max);
		}
	}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;

	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function throttle(fn, delay) {
	let lastCall = 0;

	return function (...args) {
		const now = new Date().getTime();

		if (now - lastCall < delay) {
			return
		}

		lastCall = now;
		return fn(...args)
	}
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`
		}
	}
}

if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

	;

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];

		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i
		}
	}
}

	;

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, !1) : target.attachEvent('on' + eventName, callback)
}

	;

Shopify.postLink = function (path, options) {
	options = options || {}

		;
	var method = options.method || 'post';

	var params = options.parameters || {}

		;
	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField)
	}

	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form)
}

	;

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options.hideElement || province_domid);
	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
	this.initCountry();
	this.initProvince()
}

	;

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler()
	}

	,
	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default');

		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	}

	,
	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);
		this.clearOptions(this.provinceEl);

		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		}

		else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	}

	,
	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	}

	,
	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt)
		}
	}

	,
}

	;

class MenuDrawer extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector('details');
		this.addEventListener('keyup', this.onKeyUp.bind(this));
		this.addEventListener('focusout', this.onFocusOut.bind(this));
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
		this.querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)))
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;
		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;
		openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const parentMenuElement = detailsElement.closest('.has-submenu');
		const isOpen = detailsElement.hasAttribute('open');
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		function addTrapFocus() {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
			summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

			if (window.matchMedia('(max-width: 990px)')) {
				document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
			}
		}

		else {
			setTimeout(() => {
				detailsElement.classList.add('menu-opening'); summaryElement.setAttribute('aria-expanded', !0); parentMenuElement && parentMenuElement.classList.add('submenu-open'); !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
			}

				, 100)
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		});
		summaryElement.setAttribute('aria-expanded', !0);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus = !1) {
		if (event === undefined) return;
		if (this.mainDetailsToggle && this.mainDetailsToggle.classList) {
			this.mainDetailsToggle.classList.remove('menu-opening');

			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open');
				if (details.classList) details.classList.remove('menu-opening');
			});

			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
				if (submenu.classList) submenu.classList.remove('submenu-open');
			});
		}
		document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
		removeTrapFocus(elementToFocus);
		if (this.mainDetailsToggle) this.closeAnimation(this.mainDetailsToggle);
		if (event instanceof KeyboardEvent && elementToFocus) elementToFocus.setAttribute('aria-expanded', !1);
	}

	onFocusOut() {
		setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details');
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest('.submenu-open');
		parentMenuElement && parentMenuElement.classList.remove('submenu-open');
		detailsElement.classList.remove('menu-opening');
		detailsElement.querySelector('summary').setAttribute('aria-expanded', !1);
		removeTrapFocus(detailsElement.querySelector('summary'));
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			}

			else {
				detailsElement.removeAttribute('open');

				if (detailsElement.closest('details[open]')) {
					trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
				}
			}
		}

			;
		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector('.section-header');
		this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
		document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
		this.header.classList.add('menu-open');

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		});
		summaryElement.setAttribute('aria-expanded', !0);
		window.addEventListener('resize', this.onResize);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus) {
		if (!elementToFocus) return;
		super.closeMenuDrawer(event, elementToFocus);
		if (this.header && this.header.classList) this.header.classList.remove('menu-open');
		window.removeEventListener('resize', this.onResize)
	}

	onResize = () => {
		this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
		document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
	}
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, !1));

		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide();
		});

		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
			})
		}

		else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide();
			})
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = !0;
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector('.template-popup');
		document.body.classList.add('overflow-hidden');
		this.setAttribute('open', '');
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia()
	}

	hide() {
		document.body.classList.remove('overflow-hidden');
		document.body.dispatchEvent(new CustomEvent('modalClosed'));
		this.removeAttribute('open');
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia()
	}
}

customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			if (this.innerHTML.trim() === '') {
				const productUrl = this.dataset.url.split('?')[0];

				fetch(`${productUrl}?section_id=bulk-quick-order-list`).then((response) => response.text()).then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('.quick-order-list-container').parentNode; this.innerHTML = sourceQty.innerHTML

				}).catch((e) => {
					console.error(e)
				})
			}
		}

			;
		new IntersectionObserver(handleIntersection.bind(this)).observe(document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`))
	}
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
	constructor() {
		super();
		const button = this.querySelector('button');
		if (!button) return;

		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal')); if (modal) modal.show(button);
		})
	}
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this))
	}

	loadContent(focus = !0) {
		window.pauseAllMedia();

		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0));
			this.setAttribute('loaded', !0);
			const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
			if (focus) deferredElement.focus();

			if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
				deferredElement.play()
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();

		this.slider = this.querySelector('[id^="Slider-"]');
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.enableSliderLooping = false;

		this.currentPageElement = this.querySelector('.slider-counter--current');
		this.pageTotalElement = this.querySelector('.slider-counter--total');
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		this.initPages();

		const resizeObserver = new ResizeObserver(() => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener('scroll', this.update.bind(this));
		if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
		if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el && el.clientWidth > 0);

		// Not enough slides to behave like a slider
		if (!this.sliderItemsToShow || this.sliderItemsToShow.length < 2) {
			this.currentPage = 1;
			this.totalPages = 1;
			if (this.currentPageElement) this.currentPageElement.textContent = '1';
			if (this.pageTotalElement) this.pageTotalElement.textContent = '1';
			return;
		}

		this.sliderItemOffset =
			this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

		// Guard against divide by zero
		if (!this.sliderItemOffset) {
			this.currentPage = 1;
			this.totalPages = 1;
			return;
		}

		this.slidesPerPage = Math.floor(
			(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
		);

		// Guard for weird layout where slidesPerPage becomes 0
		if (!this.slidesPerPage || this.slidesPerPage < 1) this.slidesPerPage = 1;

		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
		if (this.totalPages < 1) this.totalPages = 1;

		this.update();
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.initPages();
	}

	update() {
		if (!this.slider || !this.nextButton) return;

		const previousPage = this.currentPage || 1;

		// If sliderItemOffset isn't set yet, do nothing safely
		if (!this.sliderItemOffset) {
			this.currentPage = 1;
		} else {
			this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
		}

		// Clamp currentPage
		if (!Number.isFinite(this.currentPage) || this.currentPage < 1) this.currentPage = 1;
		if (this.totalPages && this.currentPage > this.totalPages) this.currentPage = this.totalPages;

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = String(this.currentPage);
			this.pageTotalElement.textContent = String(this.totalPages || 1);
		}

		if (this.currentPage !== previousPage) {
			this.dispatchEvent(
				new CustomEvent('slideChanged', {
					detail: {
						currentPage: this.currentPage,
						currentElement: (this.sliderItemsToShow || [])[this.currentPage - 1],
					},
				})
			);
		}

		if (this.enableSliderLooping) return;

		const items = this.sliderItemsToShow || [];
		if (!items.length) return;

		if (this.prevButton) {
			if (this.isSlideVisible(items[0]) && this.slider.scrollLeft === 0) {
				this.prevButton.setAttribute('disabled', 'disabled');
			} else {
				this.prevButton.removeAttribute('disabled');
			}
		}

		if (this.nextButton) {
			const last = items[items.length - 1];
			if (last && this.isSlideVisible(last)) {
				this.nextButton.setAttribute('disabled', 'disabled');
			} else {
				this.nextButton.removeAttribute('disabled');
			}
		}
	}

	isSlideVisible(element, offset = 0) {
		if (!this.slider || !element) return false;
		const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
		return (
			element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
			element.offsetLeft >= this.slider.scrollLeft
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		if (!this.sliderItemOffset) return;

		const step = Number(event.currentTarget?.dataset?.step || 1);
		const isNext = event.currentTarget?.name === 'next';

		this.slideScrollPosition = isNext
			? this.slider.scrollLeft + step * this.sliderItemOffset
			: this.slider.scrollLeft - step * this.sliderItemOffset;

		this.setSlidePosition(this.slideScrollPosition);
	}

	setSlidePosition(position) {
		if (!this.slider) return;
		this.slider.scrollTo({ left: position });
	}
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();

		// If base slider didn't initialize, bail safely
		if (!this.slider) return;

		this.sliderControlWrapper = this.querySelector('.slider-buttons');
		this.enableSliderLooping = true;

		// If no controls, don't run slideshow behaviors
		if (!this.sliderControlWrapper) return;

		this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
		if (!this.sliderFirstItemNode) return;

		// Announcement bar fade support (only if present)
		this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
		this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

		this.sliderControlLinksArray = Array.from(
			this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
		);
		this.sliderControlLinksArray.forEach((link) =>
			link.addEventListener('click', this.linkToSlide.bind(this))
		);

		this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
		this.setSlideVisibility();

		if (this.announcementBarSlider) {
			this.announcementBarArrowButtonWasClicked = false;
			this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

			this.reducedMotion.addEventListener('change', () => {
				if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
			});

			[this.prevButton, this.nextButton].forEach((button) => {
				if (!button) return;
				button.addEventListener(
					'click',
					() => {
						this.announcementBarArrowButtonWasClicked = true;
					},
					{ once: true }
				);
			});

			this.announcementBarSlider.classList.add('slider--initialized');
		}

		if (this.slider.getAttribute('data-autoplay') === 'true') {
			this.setAutoPlay();
		}
	}

	setAutoPlay() {
		const speed = Number(this.slider?.dataset?.speed);
		this.autoplaySpeed = Number.isFinite(speed) && speed > 0 ? speed * 1000 : 5000;

		clearInterval(this.autoplay);
		this.play();

		this.addEventListener('mouseover', this.pause.bind(this));
		this.addEventListener('mouseleave', this.play.bind(this));
		this.addEventListener('focusin', this.pause.bind(this));
		this.addEventListener('focusout', this.play.bind(this));
	}

	play() {
		if (!this.slider) return;
		clearInterval(this.autoplay);
		this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
		this.slider.setAttribute('aria-live', 'off');
	}

	pause() {
		if (!this.slider) return;
		clearInterval(this.autoplay);
		this.slider.setAttribute('aria-live', 'polite');
	}

	autoRotateSlides() {
		if (!this.slider || !this.sliderItemOffset) return;

		const itemsCount = this.sliderItems?.length || 0;
		if (itemsCount < 2) return;

		const page = Number(this.currentPage);
		if (!Number.isFinite(page) || page < 1 || page > itemsCount) {
			this.currentPage = 1;
		}

		const slideScrollPosition =
			this.currentPage === itemsCount ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

		this.setSlidePosition(slideScrollPosition);
		this.applyAnimationToAnnouncementBar();
	}

	setSlidePosition(position) {
		if (!this.slider) return;
		if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);

		this.setPositionTimeout = setTimeout(() => {
			if (this.slider) this.slider.scrollTo({ left: position });
		}, this.announcerBarAnimationDelay || 0);
	}

	setSlideVisibility() {
		const itemsToShow = this.sliderItemsToShow || [];
		if (!itemsToShow.length) return;

		const page = Number(this.currentPage);
		if (!Number.isFinite(page) || page < 1 || page > itemsToShow.length) {
			this.currentPage = 1;
		}

		itemsToShow.forEach((item, index) => {
			if (!item) return;

			const isActive = index === this.currentPage - 1;
			const links = item.querySelectorAll ? item.querySelectorAll('a') : [];

			links.forEach((a) => {
				if (isActive) a.removeAttribute('tabindex');
				else a.setAttribute('tabindex', '-1');
			});

			item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
			if (isActive) item.removeAttribute('tabindex');
			else item.setAttribute('tabindex', '-1');
		});

		this.wasClicked = false;
	}

	applyAnimationToAnnouncementBar(button = 'next') {
		if (!this.announcementBarSlider) return;

		const itemsCount = this.sliderItems?.length || 0;
		if (itemsCount < 2) return;

		const page = Number(this.currentPage);
		if (!Number.isFinite(page) || page < 1 || page > itemsCount) {
			this.currentPage = 1;
		}

		const increment = button === 'next' ? 1 : -1;
		const currentIndex = this.currentPage - 1;

		let nextIndex = (currentIndex + increment) % itemsCount;
		if (nextIndex < 0) nextIndex = itemsCount - 1;

		const currentSlide = this.sliderItems[currentIndex];
		const nextSlide = this.sliderItems[nextIndex];
		if (!currentSlide?.classList || !nextSlide?.classList) return;

		const animationClassIn = 'announcement-bar-slider--fade-in';
		const animationClassOut = 'announcement-bar-slider--fade-out';

		const isFirstSlide = currentIndex === 0;
		const isLastSlide = currentIndex === itemsCount - 1;

		const shouldMoveNext =
			(button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);

		const direction = shouldMoveNext ? 'next' : 'previous';

		currentSlide.classList.add(`${animationClassOut}-${direction}`);
		nextSlide.classList.add(`${animationClassIn}-${direction}`);

		setTimeout(() => {
			if (currentSlide?.classList) currentSlide.classList.remove(`${animationClassOut}-${direction}`);
			if (nextSlide?.classList) nextSlide.classList.remove(`${animationClassIn}-${direction}`);
		}, (this.announcerBarAnimationDelay || 0) * 2);
	}

	linkToSlide(event) {
		event.preventDefault();
		if (!this.slider || !this.sliderFirstItemNode) return;

		const idx = this.sliderControlLinksArray.indexOf(event.currentTarget);
		if (idx < 0) return;

		const page = Number(this.currentPage) || 1;
		const slideScrollPosition =
			this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (idx + 1 - page);

		this.slider.scrollTo({ left: slideScrollPosition });
	}
}

customElements.define('slideshow-component', SlideshowComponent);


// VariantSelects clean definition
class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange.bind(this));
	}

	onVariantChange(event) {
		const target = this.getInputForEventTarget(event.target);
		this.updateSelectionMetadata(event);
		publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
			data: { event, target, selectedOptionValues: this.selectedOptionValues },
		});
	}

	updateSelectionMetadata({ target }) {
		const { value, tagName } = target;
		if (tagName === 'SELECT' && target.selectedOptions.length) {
			Array.from(target.options)
				.find((option) => option.getAttribute('selected'))
				?.removeAttribute('selected');
			target.selectedOptions[0].setAttribute('selected', 'selected');
		} else if (tagName === 'INPUT' && target.type === 'radio') {
			const selectedSwatchValue = target
				.closest('.product-form__input')
				.querySelector('[data-selected-value]');
			if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
		}
	}

	getInputForEventTarget(target) {
		return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
	}

	get selectedOptionValues() {
		return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
			({ dataset }) => dataset.optionValueId
		);
	}
}

customElements.define('variant-selects', VariantSelects);

// ProductRecommendations working definition
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.loadRecommendations(this.dataset.productId);
	}

	loadRecommendations(productId) {
		const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;

		fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;

				const recommendations = html.querySelector('product-recommendations');

				// Insert content if recommendations exist
				if (recommendations?.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				// Remove block if empty & used for complementary products
				if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
					this.remove();
				}

				// Mark loaded for styling
				if (html.querySelector('.grid__item')) {
					this.classList.add('product-recommendations--loaded');
				}
			})
			.catch((e) => {
				console.error('Recommendations error:', e);
			});
	}
}

customElements.define('product-recommendations', ProductRecommendations);


class AccountIcon extends HTMLElement {
	constructor() {
		super();
		this.icon = this.querySelector('.icon')
	}

	connectedCallback() {
		document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this))
	}

	handleStorefrontSignInCompleted(event) {
		if (event?.detail?.avatar) {
			this.icon?.replaceWith(event.detail.avatar.cloneNode())
		}
	}
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
	constructor() {
		super();
		this.queue = [];
		this.requestStarted = !1;
		this.ids = []
	}

	startQueue(id, quantity) {
		this.queue.push({
			id, quantity
		});

		const interval = setInterval(() => {
			if (this.queue.length > 0) {
				if (!this.requestStarted) {
					this.sendRequest(this.queue)
				}
			}

			else {
				clearInterval(interval)
			}
		}

			, 250)
	}

	sendRequest(queue) {
		this.requestStarted = !0;

		const items = {}

			;

		queue.forEach((queueItem) => {
			items[parseInt(queueItem.id)] = queueItem.quantity
		});
		this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
		const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
		quickBulkElement.updateMultipleQty(items)
	}

	resetQuantityInput(id) {
		const input = this.querySelector(`#Quantity-${id}`);
		input.value = input.getAttribute('value');
		this.isEnterPressed = !1
	}

	setValidity(event, index, message) {
		event.target.setCustomValidity(message);
		event.target.reportValidity();
		this.resetQuantityInput(index);
		event.target.select()
	}

	validateQuantity(event) {
		const inputValue = parseInt(event.target.value);
		const index = event.target.dataset.index;

		if (inputValue < event.target.dataset.min) {
			this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min))
		}

		else if (inputValue > parseInt(event.target.max)) {
			this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max))
		}

		else if (inputValue % parseInt(event.target.step) != 0) {
			this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step))
		}

		else {
			event.target.setCustomValidity('');
			event.target.reportValidity();
			this.startQueue(index, inputValue)
		}
	}

	getSectionsUrl() {
		if (window.pageNumber) {
			return `${window.location.pathname}?page=${window.pageNumber}`
		}

		else {
			return `${window.location.pathname}`
		}
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
	}
}

if (!customElements.get('bulk-add')) {
	customElements.define('bulk-add', BulkAdd)
}
